import { isOkq8, isVillaagarna } from '../partners/partnersService';
import ProductsNumbers from '../../types/enums/productsNumbers';

export const resolvePartnerForStats = () => {
    if (isVillaagarna()) {
        return 'villaaagarna';
    } else if (isOkq8()) {
        return 'okq8';
    } else return 'gjensidige';
};

export const resolveProductNameForStats = productNumber => {
    switch (productNumber) {
        case ProductsNumbers.CAR:
            return 'bilforsakring';
        case ProductsNumbers.HEM:
            return 'hemforsakring';
        case ProductsNumbers.COMPANY_CAR:
            return 'tjanstebilforsakring';
        case ProductsNumbers.VILLA:
            return 'villahemforsakring';
        case ProductsNumbers.MOTORCYCLE:
            return 'motorcykelforsakring';
        default:
            return '';
    }
};

export const validatePathName = pathName => {
    if (pathName.endsWith('/')) {
        return pathName;
    } else return pathName + '/';
};
